export default {
    name: "OpenURL",
    title: "Open URL",
    icon: "mdi-file-link-outline",
    create() {
        return {
            name: this.name,
            description: null,
            actionType: this.name,
            url: null,
            params: [],
            target: "_blank",
        };
    },
};